import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TagDirective } from '@app/core/directives/tag.directive';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TagDirective, NgClass],
})
export class TagsComponent {
  @Input() classes: string = '';

  @Input({ required: true }) tags$!: Observable<string[] | undefined>;
}
